import { useDeeplinkRouter, useHostRoutePreset } from '@/features/deeplinks';
import useDisableTextSelection from '@/hooks/useDisableTextSelection';
import { useLibrary } from '@/hooks/useLibrary';

import useGenerationBootstrap from './useGenerationBootstrap';
import useSessionBootstrap from './useSessionBootstrap';

/**
 * Single composition root for all boot-time effects. AppContent calls
 * this once. isPending mirrors the deeplink router's blocking state so
 * the shell can render a loader until the projectJson handler (or any
 * future blocking deeplink kind) resolves.
 *
 * Single-hook calls are inlined here; the only sub-bootstrap modules are
 * the ones that actually compose multiple hooks.
 */
const useAppBootstrap = () => {
  useDisableTextSelection();
  const { isPending: isDeeplinkPending } = useDeeplinkRouter();
  // Same contract as the router's `isPending`: nothing paints while the host
  // route is still resolving, so the embed never shows a screen that the
  // preset it is about to open would replace.
  const { isPending: isHostRoutePending } = useHostRoutePreset();
  useSessionBootstrap();
  useGenerationBootstrap();
  useLibrary();
  return { isPending: isDeeplinkPending || isHostRoutePending };
};

export default useAppBootstrap;
